import styled from 'styled-components'

const FinanceMetaGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
  margin-top: 18px;
`

export default FinanceMetaGrid
